<template>
  <table class="table table-borderless table-align table-h51">
    <thead>
      <tr>
        <th>ID</th>
        <th>Name</th>
        <th>Scraper name</th>
        <th>Enable</th>
        <th class="nowrap">
            Default
          <span title="Quando ativo é elegivél para ser associado a um veículo">
            <InfoIcon size="1.5x"/>
          </span>
        </th>
        <th>App name</th>
        <th>Executor</th>
        <th>Friendly name</th>
        <th>Sphere</th>
        <th>UF</th>
        <th>Validate fields</th>
        <th>Created at</th>
        <th>Updated at</th>
        <th></th>
      </tr>
      </thead>
        <tbody>
        <tr v-for="scrapingService in scrapingServices" :key="scrapingService.id">
          <td>{{ scrapingService.id }}</td>
          <td>{{ scrapingService.name }}</td>
          <td>{{ scrapingService.scraperName }}</td>
          <td>{{ scrapingService.enable ? 'yes' : 'no' }}</td>
          <td>{{ scrapingService.default ? 'yes' : 'no' }}</td>
          <td>{{ scrapingService.appName }}</td>
          <td>{{ scrapingService.executor }}</td>
          <td>{{ scrapingService.friendlyName }}</td>
          <td>{{ scrapingService.sphere }}</td>
          <td>{{ scrapingService.uf }}</td>
          <td>{{ scrapingService.validateFields.join(', ') }}</td>
          <td>{{ scrapingService.createdAt | datetime }}</td>
          <td>{{ scrapingService.updatedAt | datetime }}</td>
          <td>
            <div class="btn-group">
              <button class="btn btn-outline" @click="$emit('showEntity', scrapingService)">
                Ver
              </button>
              <button class="btn btn-outline" @click="$emit('editEntity', scrapingService)">
                Editar
              </button>
              <button class="btn btn-outline" @click="$emit('deleteEntity', scrapingService)">
                Excluir
              </button>
            </div>
          </td>
        </tr>
      </tbody>
  </table>
</template>

<script>
import { InfoIcon } from 'vue-feather-icons'

export default {
  name: 'Table',
  components: { InfoIcon },
  props: {
    scrapingServices: { required: true, type: Array }
  }
}

</script>

<style scoped>

</style>
